

































import { Component, Prop, Vue } from 'vue-property-decorator';
import DoughnutChartBaseWrapper from '../chartjs/DoughnutChartBaseWrapper.vue';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import ChartError from '../ChartError.vue';
import { Data, DataFilter, LabelsAndData, Series } from '../../models';
import ChartNoData from '@/features/reports/components/ChartNoData.vue';
import { chartDataUtil } from '../../util/ChartDataUtil';
import shortid from 'shortid';

@Component({
	components: {
		DoughnutChartBaseWrapper,
		LoadingSpinner,
		ChartError,
		ChartNoData
	}
})
export default class TotalsDoughnutChart extends Vue {
	@Prop() public title: string;
	@Prop() public subTitle: string;
	@Prop() public loadedData: boolean;
	@Prop() public loadingError: string;
	@Prop() public data: Data;
	@Prop() public dataFilter: DataFilter;
	@Prop() public series: ((data: Data) => Series) | string;
	@Prop({ default: 10}) public maxItems: number;

	public reportId: string = '';

	public mounted() {
		this.reportId = shortid.generate();
	}

	public get processedData(): LabelsAndData {
		const labelsAndData = { labels: this.data.scale.labels, data: this.seriesData.data };

		const filter = (label: string, value: number) => value > 0;
		const filteredData = chartDataUtil.filterData(labelsAndData, filter);

		const orderedData = chartDataUtil.orderData(filteredData, {
			dataOrderAscending: false,
			forceZeroValuesToBottom: false,
		});

		return chartDataUtil.restrictDataToTopX(orderedData, {
			maxItems: this.maxItems,
			groupNonDisplayedItemsIntoOther: true,
			otherItemsLabel: 'Others'
		});
	}

	public get loadedAndReturnedData(): boolean {
		return this.loadedData && !this.isDataEmpty;
	}

	public get loadedAndNotReturnedData(): boolean {
		return this.loadedData && this.isDataEmpty;
	}

	private get isDataEmpty(): boolean {
		return !this.seriesData || this.seriesData.data.filter(val => val > 0).length === 0;
	}

	private get seriesData(): Series {
		if (typeof this.series === 'string') {
			return this.data.series.filter(series => series.name === this.series)[0];
		} else {
			return this.series(this.data);
		}
	}
}
